export const fileExtensions = {
  pdf: 'pdf',
  xlsx: 'xlsx',
  zip: 'zip',
} as const;

export interface IFileConfig {
  signedZip?: string;
  pdf: string | string[];
  pdfList?: string[];
  xlsx?: string[];
  xlsxList?: string[];
}

export type IFileExtension = typeof fileExtensions[keyof typeof fileExtensions];

export const allowedFileExtensions = [
  'jpg',
  'pdf',
  'png',
  'xlsx',
  'txt',
  'doc',
  'zip',
] as const;

export type FileExtension = typeof allowedFileExtensions[number];
